import * as THREE from 'three';

import { eventBus } from '@/hooks/useEventBus';

class Game {
  constructor(collectibleAssets, time = 60) {
    this.collectibleAssets = collectibleAssets;
    this.timeinterval;
    this.collectibleTimeinterval;
    this.score = 0;
    this.time = time;
    this.audioManager = {};
    this.collectibleAssetIds = [];
  }

  initAssets() {
    return new Promise(resolve => {
      if (this.collectibleAssets && this.collectibleAssets.length > 0) {
        let loadedCount = 0;
        const totalImages = this.collectibleAssets.length;

        this.collectibleAssets.forEach((ele, i) => {
          const img = document.createElement('img');
          img.crossOrigin = 'anonymous';

          img.onload = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
              resolve();
            }
          };

          img.onerror = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
              resolve();
            }
          };

          img.src = ele.uri;
          let id = `collectibe_${i + 1}`;
          img.id = id;
          this.collectibleAssetIds.push(id);
          const assetsEnt = document.querySelector('a-assets');
          if (assetsEnt) assetsEnt.appendChild(img);
        });
      } else {
        resolve();
      }
    });
  }
  initGroundElement = () => {
    const element = document.createElement('a-box');
    const attributes = {
      id: 'ground',

      scale: '100 1 100',
      position: '0 15 0',
      rotation: '0 0 0',
      material: 'transparent:true; opacity:0',
      'static-body':
        'shape: box; collisionFilterGroup: 1; collisionFilterMask: 2',
    };
    for (const key in attributes) {
      element.setAttribute(key, attributes[key]);
    }

    const scene = document.querySelector('a-scene');
    if (scene) scene.appendChild(element);
  };

  spawnCollectibleElement() {
    const sphereCenter = new THREE.Vector3(0, 0, -3);
    const sphereRadius = 5;

    const pointInsideSphere = () => {
      const theta = Math.random() * Math.PI * 2;
      const phi = Math.acos(2 * Math.random() - 1);
      const r = Math.cbrt(Math.random()) * sphereRadius;

      return new THREE.Vector3(
        r * Math.sin(phi) * Math.cos(theta),
        r * Math.sin(phi) * Math.sin(theta),
        Math.max(-2, r * Math.cos(phi))
      );
    };

    const localPos = pointInsideSphere();
    const worldPos = localPos.add(sphereCenter);

    const rotationY = Math.atan2(-localPos.x, -localPos.z) * (180 / Math.PI);

    const element = document.createElement('a-image');
    const randomAssetID =
      this.collectibleAssetIds[
        Math.floor(Math.random() * this.collectibleAssetIds.length)
      ];
    const attributes = {
      id: 'collectible',
      src: `#${randomAssetID}`,
      scale: '0.8 0.8 1',
      position: worldPos,
      material: 'transparent: true; opacity: 1',
      rotation: `0 ${rotationY} 0`,
      'look-at': '[camera]',
      class: 'clickable',
    };
    for (const key in attributes) {
      element.setAttribute(key, attributes[key]);
    }
    element.setAttribute('body', {
      type: 'dynamic',
      sphereRadius: 0.3,
      shape: 'sphere',
      collisionFilterGroup: 2, // Collectibles are in group 2
      collisionFilterMask: 1, // Only collide with group 1 (ground)
    });
    const scene = document.querySelector('a-scene');
    if (scene) {
      scene.appendChild(element);
    }

    element.addEventListener('click', () => {
      this.score += 50;
      const scoreEl = document.getElementById('score');
      if (scoreEl) scoreEl.innerText = this.score;

      // Add blast effect: scale up and fade out
      element.setAttribute('animation__blast', {
        property: 'scale',
        from: '0.8 0.8 10',
        to: '2 2 10',
        dur: 300,
        easing: 'easeOutQuad',
      });

      element.setAttribute('animation__fade', {
        property: 'material.opacity',
        from: 1,
        to: 0,
        dur: 300,
        easing: 'easeOutQuad',
      });

      // Remove element after animation completes
      setTimeout(() => {
        if (element.parentNode) {
          element.parentNode.removeChild(element);
        }
      }, 300);
    });
    element.addEventListener('collide', e => {
      setTimeout(() => {
        e.detail.body.el.parentNode.removeChild(e.detail.body.el);
      }, 0);
    });
  }

  startTimer() {
    if (this.time <= 0) {
      this.gameOver();
      return;
    }
    this.time = this.time - 1;
    const timeEle = document.getElementById('timer');
    if (timeEle) timeEle.innerText = this.time;
  }
  async gameStart() {
    await this.initAssets();

    this.initGroundElement();
    this.collectibleTimeinterval = setInterval(() => {
      this.spawnCollectibleElement();
    }, 800);
    this.timeinterval = setInterval(() => {
      this.startTimer();
    }, 1000);

    // setTimeout(() => {
    //   this.initGroundElement();
    // }, 0);
  }
  gameOver() {
    eventBus.emit('game_over', { score: this.score });

    clearInterval(this.collectibleTimeinterval);
    clearInterval(this.timeinterval);
  }
}

export default Game;
